module.exports = __webpack_public_path__ + "static/angularjs-176b63b6415954a6429dd14f45079c69.svg";